import { render, staticRenderFns } from "./cont_six.vue?vue&type=template&id=c37c189e&scoped=true"
import script from "./cont_six.vue?vue&type=script&lang=js"
export * from "./cont_six.vue?vue&type=script&lang=js"
import style0 from "./cont_six.vue?vue&type=style&index=0&id=c37c189e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37c189e",
  null
  
)

export default component.exports